import { useState, useEffect, useCallback } from 'react';
import getPinnedItems from '~/firebase/get/getPinnedItems';
import getOrderCountInPlatform from '~/firebase/get/getOrderCountInPlatfromItems';

import { PinnedItem } from '~/types/platform/platform';
import { ItemWithId, UniqItem } from '~/types/store/item';

import * as fp from 'lodash/fp';

export default function usePinnedItems(pinnedItems: Array<PinnedItem>) {
  const [items, setItems] = useState<Array<UniqItem>>([]);

  const handleSetItems = useCallback(
    async (pinnedItems) => {
      try {
        const newItems = await getPinnedItems(pinnedItems);
        setItems(newItems);
      } catch (err) {
        console.error('get pinned items error');
      }
    },
    [setItems],
  );

  useEffect(() => {
    if (fp.gt(pinnedItems.length, 0)) {
      handleSetItems(pinnedItems);
    }
  }, [pinnedItems]);

  useEffect(() => {
    getOrderCountInPlatform();
  }, []);
  return items;
}
